import React from "react";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import { Website } from "@/types/website";
import Layout from "@/components/Page/Layout";
import { serverSidePage } from "@/utils/serverSide";
import { TFunction } from "next-i18next";
import BoxCard from "@/components/common/BoxCard";
import ParsedHTML from "@/components/common/ParsedHTML";

type Page = {
  id: number;
  slug: string;
  title: string;
  content: string;
};

type Props = {
  currentPage: Page;
  website: Website;
  rounded?: boolean;
};

export const WebsitePage = ({
  currentPage,
  rounded = false,
}: Props): React.ReactElement => (
  <BoxCard borderRadius={rounded ? ".375rem" : 0}>
    <ParsedHTML html={currentPage.content} />
  </BoxCard>
);

WebsitePage.getLayout = function getLayout(
  page: React.ReactElement,
  t: TFunction
) {
  const { website, currentPage } = page.props;

  return (
    <Layout title={currentPage?.title ?? ""} website={website}>
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
  req,
}) => ({
  props: {
    ...(await serverSidePage(query, req, true)),
    ...(await serverSideTranslations(locale, ["common"])),
  },
});

export default WebsitePage;
